<admin-layout
    [pageTitle]="title"
    [showSearch]="false"
    [showBack]="true"
    [showMenu]="false"
>
    <div class="first-access-container">
        <mat-stepper linear [formGroup]="form">
            <mat-step label="Identificação" [stepControl]="identification">
                <div class="step-content-wrapper">
                    <div class="step-header">
                        <h1>Primeiro acesso do produtor</h1>
                        <p class="subtitle">Insira o CPF/CNPJ e o código para continuar.</p>
                    </div>

                    <form [formGroup]="identification" class="step-form">
                        <mat-form-field appearance="outline">
                            <mat-label>CPF/CNPJ</mat-label>
                            <input
                                matInput
                                placeholder="Digite o CPF ou CNPJ"
                                formControlName="identificationNumber"
                                [kzMask]="['999.999.999-99', '99.999.999/9999-99']"
                                maxlength="18"
                                required
                            />
                            @if (identificationNumberRequired) {
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Código</mat-label>
                            <input
                                matInput
                                placeholder="Código de acesso"
                                formControlName="apcId"
                                numericOnly
                                required
                            />
                            @if (apcIdRequired) {
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            }
                        </mat-form-field>

                        <div class="step-actions">
                            <button
                                mat-flat-button
                                color="primary"
                                matStepperNext
                                [disabled]="!identification.valid"
                                (click)="requestKey()"
                            >
                                Continuar
                            </button>
                        </div>
                    </form>

                </div>
            </mat-step>

            <mat-step label="Criação do Usuário" [stepControl]="registration">
                <div class="step-content-wrapper">
                    <div class="step-header">
                        <h1>Cadastre o usuário do produtor</h1>
                        <p class="subtitle">Insira e-mail e senha para criar um usuário para o produtor.</p>
                    </div>

                    <form [formGroup]="registration" class="step-form">
                        <mat-form-field appearance="outline">
                            <mat-label>E-mail</mat-label>
                            <input
                                matInput
                                formControlName="email"
                                type="email"
                                required>
                            @if (emailErrorType === 'required') {
                                <mat-error>
                                    E-mail é obrigatório.
                                </mat-error>
                            } @else if (emailErrorType === 'email') {
                                <mat-error>
                                    E-mail inválido.
                                </mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Senha</mat-label>
                            <input
                                matInput
                                formControlName="password"
                                type="password"
                                required>
                            @if (passwordErrorType === 'required') {
                                <mat-error>
                                    Senha é obrigatória.
                                </mat-error>
                            } @else if (passwordErrorType === 'minlength'
                            || passwordErrorType === 'maxlength') {
                                <mat-error>
                                    Senha deve conter entre 5 e 30 caracteres.
                                </mat-error>
                            }
                        </mat-form-field>

                        <div class="step-actions">
                            <button mat-button matStepperPrevious>Voltar</button>
                            <button
                                mat-flat-button
                                color="primary"
                                type="submit"
                                [disabled]="!registration.valid"
                                (click)="createUser()"
                            >
                                Criar Usuário
                            </button>
                        </div>
                    </form>
                </div>
            </mat-step>

        </mat-stepper>
    </div>
</admin-layout>
@if (isLoading) {
    <div class="loading-spinner">
        <mat-spinner></mat-spinner>
    </div>
}
